export default [
  "#d36845",
  "#b15b49",
  "#b65260",
  "#f29275",
  "#b3b2b2",
  "#706f6f",
];
